import { useState } from 'react';
import useErrors from '../hook/useErrors';
import ZipCodeInputMasked from './masks/ZipCodeInputMasked';
import axios from 'axios';

export default function AddressInput({ onChangeAddress, touched, error, ...props }) {
    const [isSearching, setIsSearching] = useState(false);
    const { setErrors } = useErrors();
    const getAddress = async () => {
        try {
            if (Boolean(props.value) && props.value.length === 8) {
                setIsSearching(true);
                const { data } = await axios.get(`https://viacep.com.br/ws/${props.value}/json/`);

                onChangeAddress({
                    // address: data.logradouro + ', ' + data.bairro,
                    address: data.logradouro ,
                    neighborhood: data.bairro,
                    state: data.uf,
                    city: data.localidade,
                });

                setIsSearching(false);
            }
        } catch (error) {
            console.log(error)
            setIsSearching(false);
            setErrors(error);
        }
    };
    return (
        <>
            <label className="form-label">CEP</label>
            <div className="position-relative">
                <ZipCodeInputMasked
                    type="text"
                    className={`form-control wizard-required ${touched && error ? 'is-invalid' : ''}`}
                    placeholder="Informe seu CEP"
                    {...props}
                    onBlur={getAddress}
                    //isSearching={isSearching}
                    required=""
                />
                <div className="wizard-form-error" />
            </div>
        </>
    );
}
